<template>
  <div class="inline-parent">
    <h3 :class="headingClass">{{contentElement.label_title}}
      <help-tooltip v-if="contentElement.help_text" :text="contentElement.help_text"></help-tooltip>
    </h3>
  </div>

</template>

<script lang="ts">
  import Vue from "vue";
  import {FontSizeDefinition} from "~/enums/fontSize";
  import HelpText from "~/components/helpText.vue"
  import ContentElementComponent from "./content-element-component.vue";

  export default Vue.extend({
    extends: ContentElementComponent,
    components: {HelpText},
    computed: {
      headingClass(): string {
        return FontSizeDefinition.defaultClass(this.contentElement.font_size)
      }
    }
  });
</script>